<div class="modal">
  <div class="modal-content">
      <div class="modal-header"> {{ header }} </div>
      <div class="modal-body">
          <div class="msg-wrapper">{{ msg }}</div>
          <div class="separator"></div>
          <div class="options-apicrypt">
              <div class="options-title">
                Options Complémentaires APICrypt :
              </div>
              <!-- <div class="option-apicrypt">
                <mat-slide-toggle
                    color="primary"
                    [checked]="relevageLu || false"
                    labelPosition="after"
                    (change)="toggleOptionRelevageLu()">
                  Relever les messages lus
                </mat-slide-toggle>
              </div> -->
              <div class="option-apicrypt">
                <mat-slide-toggle
                    color="primary"
                    [checked]="suppressionApresRelevage || true"
                    labelPosition="after"
                    (change)="toggleOptionSuppressionApresRelevage()">
                  Supprimer les messages du serveur une fois relevés
                </mat-slide-toggle>
              </div>
          </div>
          <div class="button-wrapper">
              <frg-button (activated)="confirmAction()">Continuer</frg-button>
              <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeConfirmationModal()">Annuler
              </frg-button>
          </div>
      </div>
  </div>
</div>
<div class="modal-background"></div>
